/* ============================================================
   ADEQO OFFERTE — driestapsformulier op /pages/offerte
   Hoort bij sections/offerte-adeqo.liquid. Gegevens en teksten komen uit
   <script data-of-data> (vertaald per taal). Bij versturen zetten we de
   keuzes uit stap 1 en 2 in de verborgen contact[...]-velden, met de
   Nederlandse waarden (v), zodat de mail altijd in het Nederlands binnenkomt.
   Ontwerp: Website/Mockups/mockup-offerte-v2.html
   ============================================================ */
(function () {
  var qf = document.getElementById('aanvraag');
  if (!qf) return;

  /* Na versturen: alleen de bedankt-staat in beeld brengen. */
  if (qf.querySelector('[data-of-done]')) {
    qf.scrollIntoView({ block: 'start' });
    return;
  }

  var dataEl = qf.querySelector('[data-of-data]');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var T = D.t;
  var $ = function (s, r) { return (r || qf).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || qf).querySelectorAll(s)); };
  var fmt = function (s, o) { return s.replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); };
  var dec = function (n) { return n.toFixed(1).replace('.', ',') ; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var state = { intent: null, mode: 'aantal', fire: 'geen' };
  qf.dataset.mode = state.mode;

  /* ---------------------------------------------------------------- stappen */
  var maxStep = 1;
  function go(n, noScroll) {
    n = +n; if (n > maxStep) maxStep = n;
    qf.dataset.step = n;
    $$('.of-qf__pane').forEach(function (p) { p.classList.toggle('is-on', +p.dataset.pane === n); });
    $$('.of-qf__step').forEach(function (b) {
      var s = +b.dataset.go;
      b.classList.toggle('is-on', s === n); b.classList.toggle('is-done', s < n);
      b.disabled = s > maxStep;
      if (s === n) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
    if (!noScroll && qf.getBoundingClientRect().top < 0) qf.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  $$('[data-next]').forEach(function (b) { b.addEventListener('click', function () { go(b.dataset.next); }); });
  $$('.of-qf__step').forEach(function (b) { b.addEventListener('click', function () { go(b.dataset.go); }); });

  /* ---------------------------------------------------------------- stap 1 */
  function setIntent(v) {
    state.intent = v;
    var r = $('input[name=of_intent][value="' + v + '"]'); if (r) r.checked = true;
    $('[data-pane="1"] [data-next]').disabled = false;
    qf.dataset.intent = v;
    if (v === 'fr') {
      setFire('Bs1');
      if (!lines().some(function (l) { return /^fr/.test(l.k); })) { clearLines(); addLine('fr300', D.frDefault); addLine('frlat', D.frDefault); }
    }
    if (v === 'gevel') { setFire('geen'); clearLines(); addLine('gv300', D.facadeDefault); addLine('gvclip'); }
    else if (lines().some(function (l) { return /^gv/.test(l.k); })) { clearLines(); addLine(); }
    var gk = $('[data-of-kleur]'), set = v === 'gevel' ? 'gv' : '';
    if ((gk.dataset.set || '') !== set) {
      $('input', gk).value = '';
      $$('.of-kp__btn, .of-kp__pop', gk).forEach(function (x) { x.remove(); });
      gk.dataset.set = set; initKp(gk);
    }
    if (v === 'maatwerk' || v === 'vraag') setMode('tekst');
    calc();
  }
  $$('input[name=of_intent]').forEach(function (r) { r.addEventListener('change', function () { setIntent(r.value); }); });

  /* ---------------------------------------------------------------- stap 2: modus */
  function setMode(m) {
    state.mode = m; qf.dataset.mode = m;
    $$('[data-of-modes] button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.mode === m); });
    $$('.of-mpane').forEach(function (p) { p.classList.toggle('is-on', p.dataset.mpane === m); });
  }
  $$('[data-of-modes] button').forEach(function (b) { b.addEventListener('click', function () { setMode(b.dataset.mode); }); });

  /* ---------------------------------------------------------------- kleurkiezer */
  var CHEV = '<svg class="of-kp__chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  var ALLC = D.colors.concat(D.facadeColors);
  function colorOf(v) { return ALLC.filter(function (x) { return x.v === v; })[0]; }
  function initKp(root) {
    var SET = root.dataset.set === 'gv' ? D.facadeColors : D.colors;
    var inp = $('input', root);
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'of-kp__btn';
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    var pop = document.createElement('div');
    pop.className = 'of-kp__pop'; pop.setAttribute('role', 'listbox'); pop.hidden = true;
    pop.innerHTML = '<button type="button" role="option" data-v=""><i class="of-kp__any"></i>' + esc(T.color_unknown) + '</button>' +
      SET.map(function (k) { return '<button type="button" role="option" data-v="' + esc(k.v) + '"><i style="--c:' + k.c + '"></i>' + esc(k.l) + '</button>'; }).join('');
    root.appendChild(btn); root.appendChild(pop);
    function paint() {
      var c = colorOf(inp.value);
      btn.innerHTML = (c ? '<i style="--c:' + c.c + '"></i>' : '<i class="of-kp__any"></i>') +
        '<span' + (c ? '' : ' class="of-kp__ph"') + '>' + esc(c ? c.l : T.choose_color) + '</span>' + CHEV;
      $$('[role=option]', pop).forEach(function (o) { o.setAttribute('aria-selected', o.dataset.v === inp.value); });
    }
    function open(on) {
      closeAll(pop);
      pop.hidden = !on; btn.setAttribute('aria-expanded', on);
      if (on) {
        /* Genoeg ruimte onder de knop? Anders naar boven openklappen. */
        root.classList.remove('of-kp--up');
        var r = btn.getBoundingClientRect(), h = pop.offsetHeight;
        if (window.innerHeight - r.bottom < h + 16 && r.top > h + 16) root.classList.add('of-kp--up');
        var sel = $('[aria-selected=true]', pop); if (sel) pop.scrollTop = sel.offsetTop - 6;
      }
    }
    btn.addEventListener('click', function () { open(pop.hidden); });
    $$('[role=option]', pop).forEach(function (o) {
      o.addEventListener('click', function () { inp.value = o.dataset.v; paint(); open(false); btn.focus(); });
    });
    paint();
  }
  function closeAll(except) {
    $$('.of-kp__pop').forEach(function (x) { if (x !== except) { x.hidden = true; x.previousSibling.setAttribute('aria-expanded', 'false'); } });
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('.of-kp')) closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------------------------------------------------------------- productregels */
  var linesEl = $('[data-of-lines]');
  function prodOf(k) { return D.products.filter(function (p) { return p.k === k; })[0]; }
  function optsP(sel) {
    var g = null, h = '';
    D.products.forEach(function (p) {
      if (p.g !== g) { if (g) h += '</optgroup>'; h += '<optgroup label="' + esc(p.g) + '">'; g = p.g; }
      h += '<option value="' + p.k + '"' + (p.k === sel ? ' selected' : '') + '>' + esc(p.l) + '</option>';
    });
    return h + '</optgroup>';
  }
  function kpHtml(set, v) { return '<div class="of-kp" data-set="' + set + '"><input type="hidden" class="of-ln__k" value="' + esc(v || '') + '"></div>'; }
  function addLine(k, color, n) {
    k = k || 'p260';
    var d = document.createElement('div'); d.className = 'of-ln';
    d.innerHTML = '<select class="of-ln__p" aria-label="' + esc(T.product) + '">' + optsP(k) + '</select>' +
      kpHtml(/^gv/.test(k) ? 'gv' : '', color) +
      '<input class="of-ln__n" type="number" min="1" inputmode="numeric" placeholder="' + esc(T.quantity) + '" aria-label="' + esc(T.quantity) + '" value="' + (n || '') + '">' +
      '<button type="button" class="of-ln__del" aria-label="' + esc(T.remove_line) + '">×</button><div class="of-ln__note"></div>';
    linesEl.appendChild(d);
    initKp($('.of-kp', d));
    $('.of-ln__p', d).addEventListener('change', function () {
      var set = /^gv/.test(this.value) ? 'gv' : '', kp = $('.of-kp', d);
      if ((kp.dataset.set || '') === set) return;
      var w = document.createElement('div'); w.innerHTML = kpHtml(set, '');
      kp.replaceWith(w.firstChild); initKp($('.of-kp', d));
    });
    d.addEventListener('input', function () { note(d); });
    d.addEventListener('change', function () { note(d); });
    d.addEventListener('click', function () { setTimeout(function () { note(d); }); });
    $('.of-ln__del', d).addEventListener('click', function () { d.remove(); if (!$('.of-ln', linesEl)) addLine(); });
    note(d);
  }
  function note(d) {
    var k = $('.of-ln__p', d).value, c = $('.of-ln__k', d).value, n = +$('.of-ln__n', d).value || 0, t = '';
    var fr = /^fr/.test(k);
    if (k === 'fr300' && c && D.frStock.indexOf(c) < 0) t = T.note_fr_custom;
    else if (!fr && /^p/.test(k) && n >= 200) t = T.note_project;
    else if (!fr && /^p/.test(k) && n >= 6) t = T.note_tier;
    else if (/^gv[0-9]/.test(k) && n >= 18) t = T.note_tier_facade;
    var el = $('.of-ln__note', d); el.textContent = t; el.style.display = t ? '' : 'none';
  }
  function lines() {
    return $$('.of-ln', linesEl).map(function (d) {
      var k = $('.of-ln__p', d).value;
      return { k: k, v: (prodOf(k) || {}).v, c: $('.of-ln__k', d).value, n: +$('.of-ln__n', d).value || 0 };
    });
  }
  function clearLines() { $$('.of-ln', linesEl).forEach(function (d) { d.remove(); }); }
  $('[data-of-addline]').addEventListener('click', function () { addLine(); });
  addLine();

  /* ---------------------------------------------------------------- wandmaten */
  var wallsEl = $('[data-of-walls]'), wc = 0;
  function addWall() {
    wc++;
    var d = document.createElement('div'); d.className = 'of-wall';
    d.innerHTML = '<b>' + esc(T.wall) + ' ' + wc + '</b>' +
      '<span class="of-unit"><input type="number" step="0.1" min="0" inputmode="decimal" placeholder="' + esc(T.width) + '" aria-label="' + esc(T.width_aria) + '"><span>m</span></span>' +
      '<span class="of-wall__x">×</span>' +
      '<span class="of-unit"><input type="number" step="0.01" min="0" inputmode="decimal" placeholder="' + esc(T.height) + '" aria-label="' + esc(T.height_aria) + '"><span>m</span></span>' +
      '<button type="button" class="of-ln__del" aria-label="' + esc(T.remove_wall) + '">×</button>';
    wallsEl.appendChild(d);
    d.addEventListener('input', calc);
    $('.of-ln__del', d).addEventListener('click', function () { d.remove(); if (!$('.of-wall', wallsEl)) addWall(); calc(); });
  }
  var num = function (i) { return parseFloat((i.value || '').replace(',', '.')); };
  var calcRes = null;
  function calc() {
    var p260 = 0, p300 = 0, half = 0, lat = 0, top = 0, m2 = 0, walls = 0, over = false, maten = [];
    var fr = state.intent === 'fr' || state.fire === 'Bs1';
    $$('.of-wall', wallsEl).forEach(function (d) {
      var i = $$('input', d), b = num(i[0]), h = num(i[1]);
      if (!(b > 0 && h > 0)) return;
      walls++; m2 += b * h; maten.push(dec(b) + ' × ' + dec(h) + ' m');
      var n = Math.ceil(b * 100 / 60);
      /* Brandvertragend bestaat alleen in 300 cm; standaard in 260 en 300. */
      if (h <= (fr ? 1.50 : 1.30)) { half += n; if (fr) p300 += Math.ceil(n / 2); else p260 += Math.ceil(n / 2); }
      else if (!fr && h <= 2.60) p260 += n;
      else if (h <= 3.00) p300 += n;
      else over = true;
      lat += 2 * Math.ceil(h / 3);
      /* Lambrisering: ook een eindlat langs de bovenkant. */
      if (h < 2.40) { var t = Math.ceil(b / 3); lat += t; top += t; }
    });
    var out = $('[data-of-calcout]');
    if (!walls) { calcRes = null; out.innerHTML = '<span>' + esc(T.calc_empty) + '</span>'; return; }
    if (state.intent === 'gevel') {
      /* Werkende dekking 0,6075 m² per plank van 300 cm. */
      var pl = Math.ceil(m2 / 0.6075);
      calcRes = { maten: maten, m2: m2, gv: pl };
      out.innerHTML = '<div class="of-calcout__row"><strong>' + esc(fmt(T.calc_planks, { n: pl })) + '</strong><span>300 cm</span><span>' + esc(fmt(T.calc_m2_facade, { m2: dec(m2) })) + '</span></div>' +
        '<p>' + esc(T.calc_facade_note) + '</p>';
      return;
    }
    var parts = [], partsNl = [];
    if (p260) { parts.push(p260 + ' × 260 cm'); partsNl.push(p260 + ' × 260 cm'); }
    if (p300) { parts.push(p300 + ' × 300 cm' + (fr ? T.calc_fr : '')); partsNl.push(p300 + ' × 300 cm' + (fr ? ' brandvertragend' : '')); }
    var tot = p260 + p300, kit = Math.ceil(tot / 2);
    calcRes = { maten: maten, m2: m2, tot: tot, lat: lat, kit: kit, txt: partsNl.join(' + '), over: over };
    out.innerHTML = '<div class="of-calcout__row"><strong>' + esc(tot ? fmt(T.calc_panels, { n: tot }) : T.calc_custom) + '</strong><span>' + esc(parts.join(' + ')) + '</span><span>' +
      esc(fmt(T.calc_m2_wall, { m2: dec(m2) })) + '</span><span>' + esc(fmt(T.calc_endlats, { n: lat })) + '</span><span>' + esc(fmt(T.calc_tubes, { n: kit })) + '</span></div>' +
      '<p>' + esc((half ? T.calc_low + ' ' : '') + (top ? fmt(T.calc_top, { n: top }) + ' ' : '') + (over ? T.calc_over + ' ' : '') + T.calc_indicative) + '</p>';
  }
  $('[data-of-addwall]').addEventListener('click', function () { addWall(); });
  addWall();

  /* ---------------------------------------------------------------- kleur en brandklasse */
  initKp($('[data-of-kleur]'));
  function setFire(f) {
    state.fire = f;
    $$('[data-of-fire] button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.fire === f); });
    $('[data-of-firenote]').classList.toggle('is-on', f === 'Bs1');
    calc();
  }
  $$('[data-of-fire] button').forEach(function (b) { b.addEventListener('click', function () { setFire(b.dataset.fire); }); });

  /* ---------------------------------------------------------------- versturen */
  function out(key, val) { var i = $('[data-of-out="' + key + '"]'); if (i) i.value = val || ''; }
  function serialize() {
    var r = $('input[name=of_intent]:checked');
    out('aanvraag', r ? r.dataset.v : '');
    var opgave = '';
    if (state.mode === 'aantal') {
      opgave = lines().map(function (l) {
        return (l.n > 0 ? l.n + ' × ' : '') + l.v + (l.c ? ', ' + l.c : '') + (l.n > 0 ? '' : ' (aantal niet ingevuld)');
      }).join('; ');
    } else if (state.mode === 'maten' && calcRes) {
      opgave = 'Wandmaten ' + calcRes.maten.join(', ') + ' (' + dec(calcRes.m2) + ' m²). Indicatie: ' +
        (calcRes.gv ? '± ' + calcRes.gv + ' gevelplanken 300 cm'
          : (calcRes.tot ? '± ' + calcRes.tot + ' panelen (' + calcRes.txt + '), ' : 'maatwerk, ') + calcRes.lat + ' eindlatten, ' + calcRes.kit + ' tubes montagekit' + (calcRes.over ? ', wand hoger dan 3 m' : ''));
    } else if (state.mode === 'tekst') {
      opgave = $('#of-vrij').value.trim();
    }
    out('opgave', opgave);
    out('kleur', state.mode === 'aantal' ? '' : $('[data-of-kleur] input').value);
    var fb = $('[data-of-fire] button[aria-pressed="true"]');
    out('brandklasse', state.intent === 'gevel' ? '' : (fb ? fb.dataset.v : ''));
    out('documenten', $$('[data-of-doc]').filter(function (c) { return c.checked; }).map(function (c) { return c.dataset.v; }).join('; '));
    if (qf.dataset.from === 'fr') $('[data-of-form]').value += ', via brandvertragende landing';
    /* Lege velden niet meesturen, anders staan er lege kopjes in de mail. */
    $$('input[name^="contact["], textarea[name^="contact["]').forEach(function (i) { i.disabled = !i.value.trim(); });
  }
  var err = $('[data-of-error]');
  var required = $$('#of-naam, #of-mail');
  qf.addEventListener('submit', function (e) {
    /* De browser keurt naam@bedrijf goed, Shopify niet; zonder deze check herlaadt de pagina en zijn stap 1 en 2 weg. */
    var bad = required.filter(function (i) { return !i.value.trim() || !i.checkValidity() || (i.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(i.value.trim())); });
    if (bad.length) {
      e.preventDefault();
      bad.forEach(function (i) { i.classList.add('is-bad'); });
      err.hidden = false; bad[0].focus();
      return;
    }
    serialize();
  });
  required.forEach(function (i) { i.addEventListener('input', function () { i.classList.remove('is-bad'); }); });

  /* ---------------------------------------------------------------- start */
  if (!err.hidden) { maxStep = 3; go(3, true); qf.scrollIntoView({ block: 'start' }); }
  else if (/[?&]aanvraag=brandvertragend\b/.test(location.search)) {
    qf.dataset.from = 'fr';
    setIntent('fr'); go(2, true);
  }
  else if (/[?&]aanvraag=maatwerk\b/.test(location.search)) {
    setIntent('maatwerk');
    if (/[?&]lijn=brandvertragend\b/.test(location.search)) { qf.dataset.from = 'fr'; setFire('Bs1'); }
    go(2, true);
  }
  /* De gevelkeuze ontbreekt waar composiet niet geleverd wordt (adeqo-facade-hidden). */
  else if (/[?&]aanvraag=gevel\b/.test(location.search) && $('input[name=of_intent][value="gevel"]')) {
    setIntent('gevel'); go(2, true);
  }
})();
